<ion-item *ngIf="store_info" class="cartProductItem">
  <ion-label class="ion-text-wrap cartProductContent">
    <div
      *ngIf="
        cartProduct &&
        (!cartProduct.enable_quantity_step || !cartProduct.quantity_step)
      "
      class="titlePaddings"
    >
      <strong style="font-size: smaller"
        >{{
          !cartProduct.disable_qty &&
          !hideQuantityFromChoicesMultiplier(cartProduct)
            ? cartProduct.quantity
            : ""
        }}
        {{
          !cartProduct.disable_qty &&
          !hideQuantityFromChoicesMultiplier(cartProduct)
            ? "x"
            : ""
        }}
        {{ cartProduct.name }}</strong
      >
    </div>

    <div
      *ngIf="
        cartProduct &&
        !(!cartProduct.enable_quantity_step || !cartProduct.quantity_step)
      "
      class="titlePaddings"
    >
      <strong style="font-size: smaller"
        >{{
          !cartProduct.disable_qty &&
          !hideQuantityFromChoicesMultiplier(cartProduct)
            ? cartProduct.quantity
            : ""
        }}{{
          !cartProduct.disable_qty &&
          !hideQuantityFromChoicesMultiplier(cartProduct) &&
          !cartProduct.quantity_step_kind
            ? " "
            : ""
        }}{{
          !cartProduct.disable_qty &&
          !hideQuantityFromChoicesMultiplier(cartProduct) &&
          !cartProduct.quantity_step_kind
            ? "x"
            : !cartProduct.disable_qty &&
              !hideQuantityFromChoicesMultiplier(cartProduct)
            ? cartProduct.quantity_step_kind
            : ""
        }}
        {{ cartProduct.name }}
        {{
          cartProduct.enable_quantity_step &&
          cartProduct.quantity_step &&
          cartProduct.quantity_step_kind &&
          cartProduct.price
            ? "(" +
              ((orderPickup == true && dineIn == false
                ? cartProduct.price_takeaway || cartProduct.price
                : orderPickup == false && dineIn == true
                ? store_info.dinein &&
                  store_info.alt_dinein_active &&
                  selectedDineInTable &&
                  selectedDineInTable.alt_dinein &&
	                  cartProduct.price_alt_dinein
	                  ? cartProduct.price_alt_dinein
	                  : cartProduct.price_dinein || cartProduct.price
	                : cartProduct.price)
	                | priceWithComma : store_info && store_info.showPricesWithComma) +
	              "€" +
	              "/" +
	              cartProduct.quantity_step_kind +
	              ")"
            : ""
        }}</strong
      >
    </div>

    <ion-text color="danger">
      <p
        style="
          font-size: x-small;
          line-height: 14px;
          font-weight: bold;
          white-space: normal;
          margin: 0px;
        "
        *ngIf="cartProduct.promotionDescription"
      >
        {{ cartProduct.promotionDescription }}
      </p>
      <p
        color="danger"
        style="
          font-size: x-small;
          line-height: 14px;
          font-weight: bold;
          white-space: normal;
          margin: 0px;
        "
        *ngIf="
          cartProduct.do_not_include_in_min_order &&
          !orderPickup &&
          cartProduct.extra_delivery_charge
        "
      >
        Δε λαμβάνεται υπόψιν στην ελάχιστη παραγγελία<br />Επιβάλλεται χρέωση
        {{ cartProduct.extra_delivery_charge }}€ αν το παραγγείλετε μόνο του!
      </p>
      <p
        style="
          font-size: x-small;
          line-height: 14px;
          font-weight: bold;
          white-space: normal;
          margin: 0px;
        "
        *ngIf="
          groupApp &&
          groupApp.pointsSystem &&
          store_info &&
          store_info.overridePromoItemsForPointsSystem &&
          cartProduct.pointsSystemException &&
          cartPrices &&
          cartPrices.currentOrderPoints &&
          cartPrices.currentOrderPoints !== '0.00' &&
          cartPrices.currentOrderPoints !== '0'
        "
      >
        <ion-text color="danger">
          {{
            "cart.cart-components.cart-list.cart-list-product-item.product-is-point-exception"
              | translate
          }}
        </ion-text>
      </p>
      <p
        style="
          font-size: x-small;
          line-height: 14px;
          font-weight: bold;
          white-space: normal;
          margin: 0px;
        "
        *ngIf="
          groupApp &&
          groupApp.pointsSystem &&
          store_info &&
          store_info.overridePromoItemsForPointsSystem &&
          !cartProduct.pointsSystemScheduleActive &&
          !cartProduct.pointsSystemException &&
          cartPrices &&
          cartPrices.currentOrderPoints &&
          cartPrices.currentOrderPoints !== '0.00' &&
          cartPrices.currentOrderPoints !== '0' &&
          cartProduct.pointsSystemWeight &&
          cartProduct.pointsSystemWeight > 1
        "
      >
        <ion-text color="primary">
          {{
            "cart.cart-components.cart-list.cart-list-product-item.you-win-points"
              | translate
          }}
          x
          {{ cartProduct.pointsSystemWeight }}
        </ion-text>
      </p>
    </ion-text>
    <h6 *ngIf="!cartProduct.gift" color="dark" class="cartProductPrice">
      <span
        *ngIf="
          (groupApp &&
            (!groupApp.design_settings ||
              !groupApp.design_settings.hideZeroPrices)) ||
          (groupApp &&
            groupApp.design_settings &&
            groupApp.design_settings.hideZeroPrices &&
            cartProduct.productTotal &&
            cartProduct.productTotal !== '0.00')
        "
        [ngClass]="{
          'line-through': !!(
            cartProduct.specialPrice !== 0 && cartProduct.specialPrice
          ),
          fontSizeSmaller: !!(
            cartProduct.specialPrice !== 0 && cartProduct.specialPrice
          )
        }"
      >
	        {{
	          cartProduct.productTotal
	            | priceWithComma : store_info && store_info.showPricesWithComma
	        }}€
      </span>

      <ion-text
        style="font-weight: 700; padding-left: 3px"
        *ngIf="
          !cartProduct.gift &&
          cartProduct.specialPrice &&
          cartProduct.specialPrice !== 0
        "
      >
	        {{
	          cartProduct.specialPriceTotal
	            | priceWithComma : store_info && store_info.showPricesWithComma
	        }}€
	      </ion-text>
	    </h6>
    <h6 *ngIf="cartProduct.gift" class="cartProductPrice">
      {{
        "cart.cart-components.cart-list.cart-list-product-item.free" | translate
      }}
    </h6>

    <app-change-quantity
      class="cartProductQuantityControls"
      *ngIf="cartProduct && !cartProduct.disable_qty"
      [buttonsSize]="'small'"
      [hiddeQuntityComponent]="hideQuantityFromChoicesMultiplier(cartProduct)"
      [disablePlusButton]="
        finalPriceLoading ||
        cartProduct.gift ||
        cartProduct.quantityOnlyFromChoices
      "
      [disableRemoveButton]="
        finalPriceLoading ||
        cartProduct.gift ||
        cartProduct.quantityOnlyFromChoices
      "
      [quantity]="cartProduct.quantity"
      [productQtyWithStep]="
        cartProduct.enable_quantity_step && cartProduct.quantity_step
      "
      [productStepKind]="cartProduct.quantity_step_kind"
      (changingQuantity)="changeProductQuantity($event)"
    ></app-change-quantity>

    <ion-text
      style="font-weight: 900; cursor: pointer"
      color="primary"
      *ngIf="
        !showProductItemDetails &&
        productHaveDetails(cartProduct) &&
        groupApp &&
        !groupApp.cartChoicesAlwaysOpen
      "
      (click)="showProductItemDetails = !showProductItemDetails"
    >
      <p>
        {{
          "cart.cart-components.cart-list.cart-list-product-item.show-more-details"
            | translate
        }}
      </p>
    </ion-text>
    <span
      *ngIf="
        groupApp && (showProductItemDetails || groupApp.cartChoicesAlwaysOpen)
      "
    >
      <div>
        <span *ngFor="let option of cartProduct.options">
          <div
            *ngIf="
              option.option_id &&
              (!option.dependenciesVariable ||
                option.dependenciesVariable.length === 0 ||
                (option.dependenciesVariable.length > 0 &&
                  option.showDependent))
            "
            class="secondaryFontSize item-text-wrap"
          >
            <p
              style="font-size: smaller; margin: 0px"
              *ngIf="
                option.type !== 'field' &&
                (!(
                  option.choices &&
                  !option.reverseChoices &&
                  (option.choices | choicesPreselected).length === 0
                ) ||
                  (option.is_require && option.availableTotal))
              "
            >
              <strong>
                {{
                  option.doNotPrint
                    ? ""
                    : option.title
                    ? option.title + ": "
                    : ""
                }}
                {{
                  option.parent_free && option.option_parent_total_price === 0
                    ? "(" +
                      ("cart.cart-components.cart-list.cart-list-product-item.free"
                        | translate) +
                      ")"
                    : option.option_parent_total_price
                    ? option.parent_free && cartProduct.parent_discount
                      ? option.option_parent_total_price +
                        "€ (-" +
                        cartProduct.parent_discount +
                        "%)"
                      : option.option_parent_total_price + "€"
                    : ""
                }}
              </strong>
              <span
                *ngIf="
                  option.type === 'checkbox' &&
                  option.reverseChoices &&
                  option.choicesComment
                "
                style="display: inline-block"
                class="mainFontSize"
                >{{ option.choicesComment }}
              </span>
              <span
                *ngFor="
                  let choice of option.choices | choicesPreselected;
                  let last = last
                "
              >
                <span
                  style="display: inline-block"
                  *ngIf="
                    !choice.bundle &&
                    !choice.doNotPrint &&
                    (option.type !== 'checkbox' ||
                      !option.reverseChoices ||
                      (!option.choicesComment && !option.reverseChoices))
                  "
                >
                  {{ choice.printLabel ? choice.printLabel : choice.title
                  }}<strong *ngIf="!choice.choicePriceComment">{{
                    choice.isFree
                      ? ("cart.cart-components.cart-list.cart-list-product-item.free-choice"
                        | translate)
                      : !choice.price
                      ? ""
                      : " " +
                        (orderPickup == true && dineIn == false
                          ? choice.price_takeaway || choice.price
                          : orderPickup == false && dineIn == true
                          ? store_info.dinein &&
                            store_info.alt_dinein_active &&
                            selectedDineInTable &&
                            selectedDineInTable.alt_dinein &&
                            choice.price_alt_dinein
                            ? choice.price_alt_dinein
                            : choice.price_dinein || choice.price
                          : choice.price) +
                        "€"
                  }}</strong
                  ><span *ngIf="choice.choicePriceComment">{{
                    choice.choicePriceComment
                  }}</span
                  >{{ last ? "" : "," }}&nbsp;
                </span>

                <app-cart-list-product-choice-comment
                  [bundleProduct]="choice.bundled_product"
                  [bundle_options]="choice.bundle_options"
                  [orderPickup]="orderPickup"
                  [store_info]="store_info"
                  [selectedDineInTable]="selectedDineInTable"
                  [dineIn]="dineIn"
                  *ngIf="
                    choice.bundle &&
                    choice.bundled_with_product_id &&
                    choice.bundled_product &&
                    !choice.doNotPrint &&
                    (option.type !== 'checkbox' ||
                      !option.reverseChoices ||
                      (!option.choicesComment && !option.reverseChoices))
                  "
                >
                </app-cart-list-product-choice-comment>
              </span>
              <!-- 
                <span
                  class="cartWarningColor"
                  ng-if="
                    option.choices &&
                    (option.choices | filter: { is_preselected: true }).length ===
                      0 &&
                    option.is_require
                  "
                >
                    {{
                      "cart.cart-components.cart-list.cart-list-product-item.you-must-make-a-choice"
                        | translate
                    }}
                </span> -->
            </p>

            <p
              style="margin: 0 auto 0 0; font-size: smaller"
              *ngIf="option.type === 'field' && option.text"
            >
              <strong>{{ option.title }}:</strong> {{ option.text }}
            </p>
          </div>
        </span>
      </div>
    </span>

    <div *ngIf="cartProduct && cartProduct | cartProductOptionRequired">
      <ion-text color="danger">
        {{
          "cart.cart-components.cart-list.cart-list-product-item.you-must-make-a-choice"
            | translate
        }}
      </ion-text>
    </div>

    <div
      *ngIf="
        cartProduct &&
        !cartProduct.availableTotal &&
        (!onlyAvailableForPreorderProductsById ||
          !onlyAvailableForPreorderProductsById[cartProduct.product_id])
      "
    >
      <ion-text color="danger">
        {{
          "cart.cart-components.cart-list.cart-list-product-item.product-needs-to-be-deleted"
            | translate
        }}
      </ion-text>
    </div>

    <div
      *ngIf="
        cartProduct &&
        !cartProduct.availableTotal &&
        (!onlyAvailableForPreorderProductsById ||
          !onlyAvailableForPreorderProductsById[cartProduct.product_id]) &&
        cartProduct.notValidMaxQuantity
      "
    >
      <ion-text color="danger">
        {{
          "cart.cart-components.cart-list.cart-list-product-item.you-have-exceeded-the-max-quantity"
            | translate
        }}
        ({{ cartProduct.maxQuantityInCart }})
      </ion-text>
    </div>

    <div
      *ngIf="
        cartProduct &&
        !cartProduct.availableTotal &&
        onlyAvailableForPreorderProductsById &&
        onlyAvailableForPreorderProductsById[cartProduct.product_id]
      "
    >
      <ion-text color="danger">
        {{
          "cart.cart-components.cart-list.cart-list-product-item.product-is-only-for-preorder-right-now"
            | translate
        }}
      </ion-text>
    </div>

    <div
      *ngIf="cartProduct && cartProduct.needsEdit && cartProduct.availableTotal"
    >
      <ion-text color="danger" [hidden]="doNotShowNeedsEditMessage">
        {{
          "cart.cart-components.cart-list.cart-list-product-item.product-needs-to-be-edited"
            | translate
        }}
      </ion-text>

      <app-product-item-order-type-tags
        [productItem]="cartProduct"
        [dineIn]="dineIn"
        [orderPickup]="orderPickup"
      ></app-product-item-order-type-tags>
    </div>

    <ion-item
      (click)="showProductValidDeliveryAreasInfoModal()"
      lines="none"
      button="true"
      detail="false"
      *ngIf="cartProduct && cartProduct.notValidDeliveryArea && selectedAddress"
    >
      <ion-label
        class="ion-text-center ion-text-wrap"
        color="danger"
        style="font-size: x-small; font-weight: bold"
      >
        {{
          "cart.cart-components.cart-list.product-has-not-valid-delivery-area-click-for-info"
            | translate
        }}
      </ion-label>

      <ion-icon
        style="font-size: 20px; margin-right: 5px"
        color="danger"
        slot="start"
        src="assets/ionicons/information-circle-outline.svg"
      >
      </ion-icon>
    </ion-item>

    <div
      style="font-size: small; font-weight: bold"
      *ngIf="
        cartProduct &&
        cartProduct.availability_stock_enabled &&
        cartProduct.availability_stock === 0 &&
        (!cartProduct.tags || !cartProduct.tags.initializationActivePreorder) &&
        (!selectedPreorderDate ||
          !selectedPreorderDate.hour ||
          !selectedPreorderDate.date ||
          !preorderDayAfterToday ||
          !cartProduct.preorder_availability_stock_enabled)
      "
    >
      <ion-text [color]="cartProduct.availability_stock ? '' : 'danger'">
        {{ "item-tags.available-stock" | translate }}:
        {{ cartProduct.availability_stock }}
      </ion-text>
    </div>

    <div
      style="font-size: small; font-weight: bold"
      *ngIf="
        cartProduct &&
        cartProduct.preorder_availability_stock_enabled &&
        cartProduct.preorder_availability_stock === 0 &&
        preorderDayAfterToday
      "
    >
      <ion-text
        [color]="cartProduct.preorder_availability_stock ? '' : 'danger'"
      >
        {{ "item-tags.available-stock" | translate }}:
        {{ cartProduct.preorder_availability_stock }}
      </ion-text>
    </div>
  </ion-label>

  <ion-button
    color="dark"
    size="small"
    style="position: absolute; top: 5px; right: 0"
    [disabled]="finalPriceLoading"
    (click)="presentAlertConfirm(cartProduct)"
    fill="clear"
  >
    <ion-icon slot="icon-only" src="assets/ionicons/close.svg"></ion-icon>
  </ion-button>

  <ion-button
    color="dark"
    size="small"
    style="position: absolute; top: 5px; right: 30px"
    [disabled]="finalPriceLoading"
    (click)="showProductDetailsModal(cartProduct)"
    fill="clear"
  >
    <ion-icon slot="icon-only" src="assets/flatIcons/cartEdit.svg"></ion-icon>
  </ion-button>

  <ion-badge
    *ngIf="
      groupApp &&
      groupApp.pointsSystem &&
      store_info &&
      store_info.overridePromoItemsForPointsSystem &&
      cartProduct.points &&
      cartPrices &&
      cartPrices.currentOrderPoints &&
      cartPrices.currentOrderPoints !== '0.00' &&
      cartPrices.currentOrderPoints !== '0'
    "
    style="position: absolute; bottom: 10px; right: 15px"
  >
    {{ cartProduct.points }}
    {{
      "cart.cart-components.cart-list.cart-list-product-item.points" | translate
    }}
  </ion-badge>

  <ion-badge
    *ngIf="
      groupApp &&
      groupApp.pointsSystem &&
      store_info &&
      !store_info.overridePromoItemsForPointsSystem &&
      store_info.design_settings &&
      store_info.design_settings.showPointRulesOnProductItems &&
      !cartProduct.gift &&
      !cartProduct.promo &&
      cartPrices &&
      cartPrices.currentOrderPoints &&
      cartPrices.currentOrderPoints !== '0.00' &&
      cartPrices.currentOrderPoints !== '0'
    "
    style="position: absolute; bottom: 10px; right: 15px"
  >
    {{ cartProduct | calculateNoPromosPointsToEarn : store_info : groupApp }}
    {{
      "cart.cart-components.cart-list.cart-list-product-item.points" | translate
    }}
  </ion-badge>
</ion-item>
